import agent from '../../services/api/agent';
import aiSessionAgent from '../../services/api/aiSessionAgent';
import { createAiSessionConnection } from '../../services/api/creatorHubConnection';
import AiSessionStore from './aiSessionStore';

/**
 * The one place the hub connection and the session store meet.
 *
 * The connection never imports the store and the store never imports SignalR, so the wiring that
 * hands one's envelopes to the other has to live outside both. This is that hop. It is deliberate
 * and is not a candidate for inlining — see
 * `docs/adr/0001-ai-session-receive-layer-connection-store-split.md`.
 */
export const createAiSessionStore = (): AiSessionStore => {
  const connection = createAiSessionConnection();

  const store = new AiSessionStore({
    connection,
    agent: aiSessionAgent,
    getCoursePages: (courseId) => agent.Course.getPages(courseId),
  });

  connection.setHandlers({
    onEnvelope: (envelope) => store.applyProgressEnvelope(envelope),
    onReconnecting: () => store.reportTransportReconnecting(),
    onReconnected: () => void store.reportTransportRestored(),
    onClosed: () => store.reportTransportLost(),
  });

  return store;
};
